import React, { FunctionComponent } from 'react';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import styles from './AlertMessage.module.scss';

interface AlertMessageProps {
    icon: IconProp;
    bgColor: string;
    bdColor: string;
    iconColor?: string;
    bWidth?: string;
    className?: string;
    children: React.ReactNode;
}

export const AlertMessage: FunctionComponent<AlertMessageProps> = ({
    icon,
    bgColor,
    bdColor,
    iconColor,
    bWidth = '1px',
    className,
    children
}) => {
    return (
        <div
            className={clsx(styles.root, className)}
            style={{
                backgroundColor: bgColor,
                borderColor: bdColor,
                borderWidth: bWidth
            }}
        >
            <div className={styles.container}>
                <div className={styles.iconContainer}>
                    <FontAwesomeIcon
                        size="xl"
                        icon={icon}
                        color={iconColor || bdColor}
                        className={styles.icon}
                    />
                </div>
                <div className={styles.content}>{children}</div>
            </div>
        </div>
    );
};

export default AlertMessage;
